import React, { Component } from 'react';

class Code extends Component {
	render() {
		return (
			<div className='code'>
				<img
					height={550}
					src='https://i.imgur.com/D5R1yfA.png'
					alt='Mathematical Expression Evauator'
				/>
			</div>
		);
	}
}

export default Code;
